export const envVariables = {
  VITE_BULK_PROVISIONING_API: import.meta.env.VITE_BULK_PROVISIONING_API,
  VITE_SIM_INVENTORY_AUTH_API: import.meta.env.VITE_SIM_INVENTORY_AUTH_API,
  VITE_BULK_PROVISIONING_AUTH_API: import.meta.env.VITE_BULK_PROVISIONING_AUTH_API,
  VITE_SIM_INVENTORY_SIGNALR: import.meta.env.VITE_SIM_INVENTORY_SIGNALR,
  VITE_SIM_INVENTORY_SIGNALR_OLD: import.meta.env.VITE_SIM_INVENTORY_SIGNALR_OLD,
  VITE_MUI_PRO_KEY: import.meta.env.VITE_MUI_PRO_KEY,
  VITE_GA_KEY: import.meta.env.VITE_GA_KEY,
  VITE_MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN,
  VITE_LOCATIONS_BASE_API: import.meta.env.VITE_LOCATIONS_BASE_API,

  VITE_AUDIT_TRAIL_AUTH_API: import.meta.env.VITE_AUDIT_TRAIL_AUTH_API,
  VITE_SIM_INVENTORY_BASE_API: import.meta.env.VITE_SIM_INVENTORY_BASE_API,
  VITE_AUDIT_TRAIL_BASE_API: import.meta.env.VITE_AUDIT_TRAIL_BASE_API,

  VITE_SIM_INVENTORY_SIMS_PROFILE_MODULE_API: import.meta.env
    .VITE_SIM_INVENTORY_SIMS_PROFILE_MODULE_API,
  VITE_SIM_INVENTORY_SIMS_PROFILE_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_SIMS_PROFILE_MODULE_API
  }`,
  VITE_SIM_INVENTORY_SIMS_PROFILE_SESSIONS_MODULE_API: import.meta.env
    .VITE_SIM_INVENTORY_SIMS_PROFILE_SESSIONS_MODULE_API,
  VITE_SIM_INVENTORY_SIMS_PROFILE_SESSIONS_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_SIMS_PROFILE_SESSIONS_MODULE_API
  }`,
  VITE_SIM_INVENTORY_SIMS_PROFILE_SESSIONS_LIST_API: `${
    import.meta.env.VITE_SIM_INVENTORY_BASE_API
  }${import.meta.env.VITE_SIM_INVENTORY_SIMS_PROFILE_SESSIONS_LIST_MODULE_API}`,

  VITE_SIM_INVENTORY_RSIMS_PROFILE_MODULE_API: import.meta.env
    .VITE_SIM_INVENTORY_RSIMS_PROFILE_MODULE_API,
  VITE_SIM_INVENTORY_RSIMS_PROFILE_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_RSIMS_PROFILE_MODULE_API
  }`,
  VITE_SIM_INVENTORY_RSIMS_PROFILE_LAST_POLLING_TIMESTAMP_API: `${
    import.meta.env.VITE_SIM_INVENTORY_BASE_API
  }${import.meta.env.VITE_SIM_INVENTORY_RSIMS_PROFILE_LAST_POLLING_TIMESTAMP_MODULE_API}`,

  VITE_SIM_INVENTORY_RSIMS_IMPORT_INGESTION_API: `${
    import.meta.env.VITE_RSIM_INVENTORY_INGESTION_BASE_API
  }${import.meta.env.VITE_SIM_INVENTORY_RSIMS_PROFILE_MODULE_API}`,

  VITE_ESIMS_INGESTION_API: `${import.meta.env.VITE_RSIM_INVENTORY_INGESTION_BASE_API}`,

  VITE_SIM_INVENTORY_ACCOUNTS_MODULE_API: import.meta.env.VITE_SIM_INVENTORY_ACCOUNTS_MODULE_API,
  VITE_SIM_INVENTORY_ACCOUNTS_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_ACCOUNTS_MODULE_API
  }`,

  VITE_SIM_INVENTORY_PRODUCT_CODES_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_PRODUCT_CODES_MODULE_API
  }`,

  VITE_SIM_INVENTORY_OTA_MODULE_API: import.meta.env.VITE_SIM_INVENTORY_OTA_MODULE_API,
  VITE_SIM_INVENTORY_OTA_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_OTA_MODULE_API
  }`,

  VITE_RSIM_INVENTORY_INGESTION_OTA_API: `${
    import.meta.env.VITE_RSIM_INVENTORY_INGESTION_BASE_API
  }${import.meta.env.VITE_SIM_INVENTORY_OTA_MODULE_API}`,

  VITE_SIM_INVENTORY_OTA_POLLING_NOTIFICATIONS_MODULE_API: import.meta.env
    .VITE_SIM_INVENTORY_OTA_POLLING_NOTIFICATIONS_MODULE_API,
  VITE_SIM_INVENTORY_OTA_POLLING_NOTIFICATIONS_API: `${
    import.meta.env.VITE_SIM_INVENTORY_BASE_API
  }${import.meta.env.VITE_SIM_INVENTORY_OTA_POLLING_NOTIFICATIONS_MODULE_API}`,

  VITE_SIM_INVENTORY_DEVICES_MODULE_API: import.meta.env.VITE_SIM_INVENTORY_DEVICES_MODULE_API,
  VITE_SIM_INVENTORY_DEVICES_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_OTA_DEVICES_API
  }`,

  VITE_SIM_INVENTORY_FEATURE_FLAGS_MODULE_API: import.meta.env
    .VITE_SIM_INVENTORY_FEATURE_FLAGS_MODULE_API,
  VITE_SIM_INVENTORY_FEATURE_FLAGS_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_FEATURE_FLAGS_MODULE_API
  }`,

  VITE_SIM_INVENTORY_MOBILE_NETWORK_OPERATORS_MODULE_API: import.meta.env
    .VITE_SIM_INVENTORY_MOBILE_NETWORK_OPERATORS_MODULE_API,
  VITE_SIM_INVENTORY_MOBILE_NETWORK_OPERATORS_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_MOBILE_NETWORK_OPERATORS_MODULE_API
  }`,

  VITE_SIM_INVENTORY_PERMISSIONS_MODULE_API: import.meta.env
    .VITE_SIM_INVENTORY_PERMISSIONS_MODULE_API,
  VITE_SIM_INVENTORY_PERMISSIONS_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_PERMISSIONS_MODULE_API
  }`,

  VITE_SIM_INVENTORY_REPORTING_MODULE_API: import.meta.env.VITE_SIM_INVENTORY_REPORTING_MODULE_API,
  VITE_SIM_INVENTORY_REPORTING_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_REPORTING_MODULE_API
  }`,

  VITE_SIM_INVENTORY_USERS_MODULE_API: import.meta.env.VITE_SIM_INVENTORY_USERS_MODULE_API,
  VITE_SIM_INVENTORY_USER_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_INVENTORY_USERS_MODULE_API
  }`,

  VITE_SIM_PRODUCTS_MODULE_API: import.meta.env.VITE_SIM_PRODUCTS_MODULE_API,
  VITE_SIM_PRODUCTS_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_SIM_PRODUCTS_MODULE_API
  }`,

  VITE_RSIM_PRODUCTS_MODULE_API: import.meta.env.VITE_RSIM_PRODUCTS_MODULE_API,
  VITE_RSIM_PRODUCTS_API: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_RSIM_PRODUCTS_MODULE_API
  }`,

  VITE_AUDIT_TRAIL_SIM_PROFILE_MODULE: import.meta.env.VITE_AUDIT_TRAIL_SIM_PROFILE_MODULE,
  VITE_AUDIT_TRAIL_SIM_PROFILE_API: `${import.meta.env.VITE_AUDIT_TRAIL_BASE_API}${
    import.meta.env.VITE_AUDIT_TRAIL_SIM_PROFILE_MODULE
  }`,

  VITE_BULK_PROVISIONING_BASE_API: import.meta.env.VITE_BULK_PROVISIONING_BASE_API,

  VITE_BULK_PROVISIONING_PERMISSIONS_MODULE_API: import.meta.env
    .VITE_BULK_PROVISIONING_PERMISSIONS_MODULE_API,
  VITE_BULK_PROVISIONING_PERMISSIONS_API: `${import.meta.env.VITE_BULK_PROVISIONING_BASE_API}${
    import.meta.env.VITE_BULK_PROVISIONING_PERMISSIONS_MODULE_API
  }`,

  VITE_BULK_PROVISIONING_PROVISIONING_REQUESTS_MODULE_API: import.meta.env
    .VITE_BULK_PROVISIONING_PROVISIONING_REQUESTS_MODULE_API,
  VITE_BULK_PROVISIONING_PROVISIONING_REQUESTS_API: `${
    import.meta.env.VITE_BULK_PROVISIONING_BASE_API
  }${import.meta.env.VITE_BULK_PROVISIONING_PROVISIONING_REQUESTS_MODULE_API}`,

  VITE_BULK_PRODUCTS_MANAGEMENT_MODULE_API: import.meta.env
    .VITE_BULK_PRODUCTS_MANAGEMENT_MODULE_API,
  VITE_BULK_PRODUCTS_MANAGEMENT_MODULE_REQUESTS_API: `${
    import.meta.env.VITE_BULK_PROVISIONING_BASE_API
  }${import.meta.env.VITE_BULK_PRODUCTS_MANAGEMENT_MODULE_API}`,

  VITE_BULK_PROVISIONING_PROVISIONING_FEATURE_FLAGS_MODULE_API: import.meta.env
    .VITE_BULK_PROVISIONING_PROVISIONING_FEATURE_FLAGS_MODULE_API,
  VITE_BULK_PROVISIONING_PROVISIONING_FEATURE_FLAGS_API: `${
    import.meta.env.VITE_BULK_PROVISIONING_BASE_API
  }${import.meta.env.VITE_BULK_PROVISIONING_PROVISIONING_FEATURE_FLAGS_MODULE_API}`,

  VITE_AUDIT_TRAIL_FEATURE_FLAGS_MODULE_API: import.meta.env
    .VITE_AUDIT_TRAIL_FEATURE_FLAGS_MODULE_API,
  VITE_AUDIT_TRAIL_FEATURE_FLAGS_API: `${import.meta.env.VITE_AUDIT_TRAIL_BASE_API}${
    import.meta.env.VITE_AUDIT_TRAIL_FEATURE_FLAGS_MODULE_API
  }`,

  VITE_AUDIT_TRAIL_REPORTING_MODULE_API: import.meta.env.VITE_AUDIT_TRAIL_REPORTING_MODULE_API,
  VITE_AUDIT_TRAIL_REPORTING_API: `${import.meta.env.VITE_AUDIT_TRAIL_BASE_API}${
    import.meta.env.VITE_AUDIT_TRAIL_REPORTING_MODULE_API
  }`,

  VITE_AUDIT_TRAIL_PERMISSIONS_MODULE_API: import.meta.env.VITE_AUDIT_TRAIL_PERMISSIONS_MODULE_API,
  VITE_AUDIT_TRAIL_PERMISSIONS_API: `${import.meta.env.VITE_AUDIT_TRAIL_BASE_API}${
    import.meta.env.VITE_AUDIT_TRAIL_PERMISSIONS_MODULE_API
  }`,
  VITE_KEYCLOAK_CHANGE_PASSWORD_URL: import.meta.env.VITE_KEYCLOAK_CHANGE_PASSWORD_URL,
  VITE_KEYCLOAK_USER_MANAGEMENT_URL: import.meta.env.VITE_KEYCLOAK_USER_MANAGEMENT_URL,
  VITE_USAGE_TRACKING_MODULE_URL: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_USAGE_TRACKING_MODULE_API
  }`,
  VITE_PRODUCTS_USAGE_TRACKING_MODULE_URL: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_PRODUCTS_USAGE_TRACKING_MODULE_API
  }`,
  VITE_ANALYTICS_MODULE_URL: `${import.meta.env.VITE_SIM_INVENTORY_BASE_API}${
    import.meta.env.VITE_ANALYTICS_MODULE_API
  }`,
};
